<?xml version="1.0" encoding="UTF-8"?>
<svg width="256px" height="256px" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>icon-justified-complete</title>
    <g id="icon-justified-complete" stroke="none" stroke-width="1"  fill-rule="evenodd">
        <path d="M257,186 L257,224 L0,224 L0,186 L257,186 Z M257,110 L257,148 L0,148 L0,110 L257,110 Z M256,32 L256,70 L0,70 L0,32 L256,32 Z" id="Combined-Shape" fill-rule="nonzero"></path>
    </g>
</svg>